export const tokenGenerator = () => {
  const chars = `0123456789abcdlmnovwxyzABCDLMNOWXYZ~!@#$%^&*()_+-={}[]:\";'<>?,./|\\ ${Date.now()}}`;
  var result = "";
  for (var i = 30; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
};
